import React from 'react';

import ESignListWindow from "../components/ESignListWindow";
import {eSignActions} from "../../../store/actions";
import {eSignService} from "../../../store/services";
import {DOCUMENT_VIEWER_MODES} from "../../../constants/DOCUMENT_VIEWER_MODES";
import {isNull, isSet} from "underscore";
import {ESIGNING_STATUS} from "../../../constants/ESIGNING_STATUS";

const ESignListDocument = (props) => {
  const {
    initialStatus
  } = props.location;

  return (<ESignListWindow
    initialStatus={(typeof initialStatus !== 'undefined') ?
      (isNull(initialStatus) ? ESIGNING_STATUS.COMPLETED : initialStatus) :
      (ESIGNING_STATUS.COMPLETED) }
    includeStatusFilter
    includeBeginDate
    includeEndDate
    viewer={DOCUMENT_VIEWER_MODES.ESIGNING}
    getESignDocumentFromESignServiceMethod={documentFields => eSignService.getESignDocumentById(documentFields)}
    searchESignDocumentFromESignDocumentServiceMethod={eSignActions.getESignDocuments}
  />);
}

export default ESignListDocument;
